( function( $ ) {

  $( document ).on( 'click', '.btn-webmail, .close-block-webmail', function( event ) {
    event.preventDefault();

    $( '.desk-webmail' ).toggleClass( 'webmail-is-open' );
  })

  $( document ).on( 'click', '.sw-send-form', function( event ) {
    event.preventDefault();

    var formData = $( this ).parents( '.send-webmail' );


    if ( formData.valid() ) {
      formData[0].submit()

      formData[0].reset();

      if ( $( window ).width() >= 1200 )
        $( '.desk-webmail' ).toggleClass( 'webmail-is-open' );
    }
    else {
      if ( $( '.error' ).parent().find( 'span' ).length == 0 )
        $( '.error' ).parent().append( $( "<span></span>" ).addClass( 'invalid' ) );

      return false;
    }
  });

})( jQuery );